module.exports = __webpack_public_path__ + "static/media/logoh.65fc2023.svg";